const StoresCardListSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="overflow-hidden" ref={viewRef}>
      <div className="enki-heading-lg mb-3 mt-7 w-[140px] h-[24px] bg-surface-200-bg ml-5 skeleton"></div>
      <div className="flex pl-2">
        {[1, 2].map((item, index) => {
          return (
            <div
              key={`${index}-${item}`}
              className="flex w-unset box-border rounded-2xl border border-solid border-surface-100-hairline ml-3"
              style={{ width: 'auto' }}>
              <div className="p-[10px] box-border w-[270px] h-[264px] text-left">
                <>
                  <div>
                    <div className="w-[140px] h-[24px] bg-surface-200-bg skeleton"></div>
                    <div className="w-[200px] h-[15px] bg-surface-200-bg skeleton mt-[2px]"></div>
                  </div>
                  <div className="mt-[6px]">
                    <div className="w-[125px] h-[17px] bg-surface-200-bg skeleton rounded-600"></div>
                  </div>

                  <div className="flex pt-3 ml-[-10px]">
                    {[1, 2].map((i, idx) => {
                      return (
                        <div className="w-[120px] ml-[10px]" key={`${i}-${idx}`}>
                          <div className="rounded-2xl overflow-hidden w-full h-[120px] skeleton bg-surface-200-bg ">
                            <div className="w-full h-full default-img"></div>
                          </div>
                          <div className="w-full h-5 mt-[5px]  bg-surface-200-bg skeleton"></div>
                          <div className="w-1/2 h-5 mt-[5px]  bg-surface-200-bg skeleton"></div>
                        </div>
                      );
                    })}
                  </div>
                </>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StoresCardListSkeleton;
